import {
  ClaveEstrategiaDte,
  EstrategiaDte,
  FilaEstrategiaDte,
  VersionDte,
} from "../../interfaces/utils/estrategias-documentos.interface";
import {
  TIPO_DTE,
  VERSION_DTE_DESCONOCIDA,
  versionDteEmision,
  versionDteNormativaV1,
  versionDteNormativaV2,
} from "../../utils/version-documento.utils";
import {
  calcularTributoNoAplica,
  calcularTributoPorCantidadAplicaV1,
  mapearFormProductoConIvaYExentoV1,
  mapearFormProductoConTipoItemV1,
  mapearFormProductoSinCambios,
} from "./estrategias-documentos.v1";
import {
  calcularTributoNoAplicaV2,
  calcularTributoPorCantidadAplicaV2,
  mapearFormProductoConIvaYExentoV2,
  mapearFormProductoConTipoItemV2,
  mapearFormProductoSinCambiosV2,
} from "./estrategias-documentos.v2";

export const VERSION_DTE_V1_GENERICA: VersionDte = 1;

export const TIPO_DTE_NO_REGISTRADO = "";

export { TIPO_DTE };

export const versionDtePorTipoNormativaV1 = (tipoDte: string): VersionDte =>
  versionDteNormativaV1(tipoDte);

export const versionDtePorTipoNormativaV2 = (tipoDte: string): VersionDte =>
  versionDteNormativaV2(tipoDte);

export const versionDteDeEmpresa = (tipoDte: string, empresa: any): VersionDte =>
  versionDteEmision(tipoDte, empresa);

export const claveEstrategiaDte = (tipoDte: string, versionDte: VersionDte): ClaveEstrategiaDte =>
  `${tipoDte}|${versionDte}`;

export const ESTRATEGIA_DTE_NO_REGISTRADA: EstrategiaDte = {
  tipoDte: TIPO_DTE_NO_REGISTRADO,
  versionDte: VERSION_DTE_DESCONOCIDA,
  mapearFormCatalogoProducto: mapearFormProductoSinCambios,
  calcularTributo: calcularTributoNoAplica,
};

const FILAS_ESTRATEGIAS_DTE_V1: ReadonlyArray<FilaEstrategiaDte> = [
  { tipoDte: TIPO_DTE.FACTURA,                 mapearFormCatalogoProducto: mapearFormProductoConTipoItemV1,   calcularTributo: calcularTributoPorCantidadAplicaV1 },
  { tipoDte: TIPO_DTE.CREDITO_FISCAL,          mapearFormCatalogoProducto: mapearFormProductoConIvaYExentoV1, calcularTributo: calcularTributoPorCantidadAplicaV1 },
  { tipoDte: TIPO_DTE.NOTA_REMISION,           mapearFormCatalogoProducto: mapearFormProductoConIvaYExentoV1, calcularTributo: calcularTributoPorCantidadAplicaV1 },
  { tipoDte: TIPO_DTE.NOTA_CREDITO,            mapearFormCatalogoProducto: mapearFormProductoConIvaYExentoV1, calcularTributo: calcularTributoPorCantidadAplicaV1 },
  { tipoDte: TIPO_DTE.NOTA_DEBITO,             mapearFormCatalogoProducto: mapearFormProductoConIvaYExentoV1, calcularTributo: calcularTributoPorCantidadAplicaV1 },
  { tipoDte: TIPO_DTE.COMPROBANTE_RETENCION,   mapearFormCatalogoProducto: mapearFormProductoSinCambios,      calcularTributo: calcularTributoNoAplica            },
  { tipoDte: TIPO_DTE.COMPROBANTE_LIQUIDACION, mapearFormCatalogoProducto: mapearFormProductoSinCambios,      calcularTributo: calcularTributoNoAplica            },
  { tipoDte: TIPO_DTE.DOCUMENTO_LIQUIDACION,   mapearFormCatalogoProducto: mapearFormProductoSinCambios,      calcularTributo: calcularTributoNoAplica            },
  { tipoDte: TIPO_DTE.FACTURA_EXPORTACION,     mapearFormCatalogoProducto: mapearFormProductoConIvaYExentoV1, calcularTributo: calcularTributoNoAplica            },
  { tipoDte: TIPO_DTE.SUJETO_EXCLUIDO,         mapearFormCatalogoProducto: mapearFormProductoConTipoItemV1,   calcularTributo: calcularTributoNoAplica            },
];

const FILAS_ESTRATEGIAS_DTE_V2: ReadonlyArray<FilaEstrategiaDte> = [
  { tipoDte: TIPO_DTE.FACTURA,                 mapearFormCatalogoProducto: mapearFormProductoConTipoItemV2,   calcularTributo: calcularTributoPorCantidadAplicaV2 },
  { tipoDte: TIPO_DTE.CREDITO_FISCAL,          mapearFormCatalogoProducto: mapearFormProductoConIvaYExentoV2, calcularTributo: calcularTributoPorCantidadAplicaV2 },
  { tipoDte: TIPO_DTE.NOTA_REMISION,           mapearFormCatalogoProducto: mapearFormProductoConIvaYExentoV2, calcularTributo: calcularTributoPorCantidadAplicaV2 },
  { tipoDte: TIPO_DTE.NOTA_CREDITO,            mapearFormCatalogoProducto: mapearFormProductoConIvaYExentoV2, calcularTributo: calcularTributoPorCantidadAplicaV2 },
  { tipoDte: TIPO_DTE.NOTA_DEBITO,             mapearFormCatalogoProducto: mapearFormProductoConIvaYExentoV2, calcularTributo: calcularTributoPorCantidadAplicaV2 },
  { tipoDte: TIPO_DTE.COMPROBANTE_RETENCION,   mapearFormCatalogoProducto: mapearFormProductoSinCambiosV2,    calcularTributo: calcularTributoNoAplicaV2          },
  { tipoDte: TIPO_DTE.COMPROBANTE_LIQUIDACION, mapearFormCatalogoProducto: mapearFormProductoSinCambiosV2,    calcularTributo: calcularTributoNoAplicaV2          },
  { tipoDte: TIPO_DTE.DOCUMENTO_LIQUIDACION,   mapearFormCatalogoProducto: mapearFormProductoSinCambiosV2,    calcularTributo: calcularTributoNoAplicaV2          },
  { tipoDte: TIPO_DTE.FACTURA_EXPORTACION,     mapearFormCatalogoProducto: mapearFormProductoConIvaYExentoV2, calcularTributo: calcularTributoNoAplicaV2          },
  { tipoDte: TIPO_DTE.SUJETO_EXCLUIDO,         mapearFormCatalogoProducto: mapearFormProductoConTipoItemV2,   calcularTributo: calcularTributoNoAplicaV2          },
];

const registrarFilas = (
  filas: ReadonlyArray<FilaEstrategiaDte>,
  versionDeTipo: (tipoDte: string) => VersionDte
): Record<ClaveEstrategiaDte, EstrategiaDte> =>
  filas.reduce((tabla: Record<ClaveEstrategiaDte, EstrategiaDte>, fila: FilaEstrategiaDte) => {
    const versionDte = versionDeTipo(fila.tipoDte);
    tabla[claveEstrategiaDte(fila.tipoDte, versionDte)] = { ...fila, versionDte };
    return tabla;
  }, {});

export const TABLA_ESTRATEGIAS_DTE: Readonly<Record<ClaveEstrategiaDte, EstrategiaDte>> = {
  ...registrarFilas(FILAS_ESTRATEGIAS_DTE_V1, () => VERSION_DTE_V1_GENERICA),
  ...registrarFilas(FILAS_ESTRATEGIAS_DTE_V1, versionDtePorTipoNormativaV1),
  ...registrarFilas(FILAS_ESTRATEGIAS_DTE_V2, versionDtePorTipoNormativaV2),
};

export const obtenerEstrategiaDte = (
  tipoDte: string,
  versionDte: VersionDte = versionDtePorTipoNormativaV1(tipoDte)
): EstrategiaDte => TABLA_ESTRATEGIAS_DTE[claveEstrategiaDte(tipoDte, versionDte)] ?? ESTRATEGIA_DTE_NO_REGISTRADA;

export * from "./estrategias-documentos.v1";
export * from "./estrategias-documentos.v2";
